import React, {PropTypes} from 'react';
import { PageHeader, Row, Col, Grid, Image, Thumbnail, Panel } from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import moment from 'moment';
import Paper from 'material-ui/Paper';
import ActionAndroid from 'material-ui/svg-icons/action/android';
import SvgIcon from 'material-ui/SvgIcon';
import numeral from 'numeral';
// SHARED
import RangePicker from '../core/components/RangePicker'
import BackNavLink from '../core/components/BackNavLink'
import muiTheme from '../utils/muiTheme'

  const iconStyles = {
    lineHeight:"normal",
    textIndent:0,
    textAlign:"start",
    textDecorationLine:"none",
    textDecorationStyle:"solid",
    textDecorationColor: "#000",
    textTransform:"none",
    blockProgression:"tb",
    isolation:"auto",
    mixBlendMode:"normal"
  };

  const svgStyleGreen ={
    fill: "#31b59f",
    width: "25px",
    height: "25px"
  }
  const svgStyleWhite ={
    fill: "#ffffff",
    width: "25px",
    height: "25px"
  }
  const CalendarIcon = (props) => (
    <SvgIcon {...props}>
       <path style={iconStyles} d="M 12 0 C 10.906937 0 10 0.9069372 10 2 L 10 4 L 4 4 C 3.4777778 4 2.9453899 4.1913289 2.5683594 4.5683594 C 2.1913289 4.9453899 2 5.4777778 2 6 L 2 46 C 2 46.522222 2.1913289 47.05461 2.5683594 47.431641 C 2.9453899 47.808671 3.4777778 48 4 48 L 46 48 C 46.522222 48 47.05461 47.808671 47.431641 47.431641 C 47.808671 47.05461 48 46.522222 48 46 L 48 6 C 48 5.4777778 47.808671 4.9453899 47.431641 4.5683594 C 47.05461 4.1913289 46.522222 4 46 4 L 40 4 L 40 2 C 40 0.9069372 39.093063 0 38 0 L 36 0 C 34.906937 0 34 0.9069372 34 2 L 34 4 L 16 4 L 16 2 C 16 0.9069372 15.093063 0 14 0 L 12 0 z M 12 2 L 14 2 L 14 8 L 12 8 L 12 2 z M 36 2 L 38 2 L 38 8 L 36 8 L 36 2 z M 4 6 L 10 6 L 10 8 C 10 9.0930628 10.906937 10 12 10 L 14 10 C 15.093063 10 16 9.0930628 16 8 L 16 6 L 34 6 L 34 8 C 34 9.0930628 34.906937 10 36 10 L 38 10 C 39.093063 10 40 9.0930628 40 8 L 40 6 L 46 6 L 46 13 L 4 13 L 4 6 z M 4 15 L 46 15 L 46 46 L 4 46 L 4 15 z M 10 19 L 10 20 L 10 42 L 30 42 L 40 42 L 40 19 L 10 19 z M 12 21 L 17 21 L 17 26 L 12 26 L 12 21 z M 19 21 L 24 21 L 24 26 L 19 26 L 19 21 z M 26 21 L 31 21 L 31 26 L 26 26 L 26 21 z M 33 21 L 38 21 L 38 26 L 33 26 L 33 21 z M 12 28 L 17 28 L 17 33 L 12 33 L 12 28 z M 19 28 L 24 28 L 24 33 L 19 33 L 19 28 z M 26 28 L 31 28 L 31 33 L 26 33 L 26 28 z M 33 28 L 38 28 L 38 33 L 33 33 L 33 28 z M 12 35 L 17 35 L 17 40 L 12 40 L 12 35 z M 19 35 L 24 35 L 24 40 L 19 40 L 19 35 z M 26 35 L 31 35 L 31 40 L 30 40 L 26 40 L 26 35 z M 33 35 L 38 35 L 38 40 L 33 40 L 33 35 z"/>
    </SvgIcon>
  );

  const DocumentIcon = (props) => (
    <SvgIcon {...props}>
      <path style={iconStyles} d="M 7 2 L 7 3 L 7 47 L 7 48 L 8 48 L 42 48 L 43 48 L 43 47 L 43 15 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 L 30 2 L 8 2 L 7 2 z M 9 4 L 29 4 L 29 15 L 29 16 L 30 16 L 41 16 L 41 46 L 9 46 L 9 4 z M 31 5.4375 L 39.5625 14 L 31 14 L 31 5.4375 z M 15 22 L 15 24 L 35 24 L 35 22 L 15 22 z M 15 28 L 15 30 L 31 30 L 31 28 L 15 28 z M 15 34 L 15 36 L 35 36 L 35 34 L 15 34 z" color="#000" overflow="visible" enable-background="accumulate" font-family="Bitstream Vera Sans"/>
    </SvgIcon>
  );

export default class MainContentShowClient extends React.Component {
  state = {
    byDateOpen: false
  }

  handleSendReport(event){
    const {handleSendReport} = this.props;

    handleSendReport(this.state.selected_dates);
  }

  handleTouchTap = (event) => {
    // This prevents ghost click.
    event.preventDefault();
    console.log("handleTouchTap");

    this.setState({
      byDateOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      byDateOpen: false,
    });

    this.props.onDateChange(this.state.selected_dates);
  };

  handleChangeRange(from, to){
    console.log("handleChangeRange");
    if (from==null || to==null ) return console.log(from,to, 'is null')
    // bug with .month() replaced with format('M')
    this.setState({
      "selected_dates": {
        start_day: moment(from).date(),
        start_month: moment(from).format('M'),
        start_year: moment(from).year(),
        end_day: moment(to).date(),
        end_month: moment(to).format('M'),
        end_year: moment(to).year()
      }
    })
  }

  render() {
    const { userProfile } = this.props

    var chooseDatesButtonTitle = "This Year"
    if (this.state.selected_dates) {
      chooseDatesButtonTitle = this.state.selected_dates.start_month + "/" + this.state.selected_dates.start_day + "/" + this.state.selected_dates.start_year + " - " + this.state.selected_dates.end_month + "/" + this.state.selected_dates.end_day + "/" + this.state.selected_dates.end_year
    }

    return (
      <div className="main-content-component main-content-show-client">

        <BackNavLink to="/accountants" />

        <PageHeader>{userProfile.name} {userProfile.last} {userProfile.email}</PageHeader>
        <Grid className="main-container" fluid={true}>
          <Row className="show-grid">
            <Col xs={12} sm={12} md={4}>
                <h4 className="column-title">Client Overview</h4>
            </Col>
            <Col xs={12} sm={12} md={8}>
                <div>
                  <MuiThemeProvider muiTheme={muiTheme}>
                    <RaisedButton
                      onClick={this.handleSendReport.bind(this)}
                      label="Generate Full Report"
                      className="raised-button raised-button-green send-report-button"
                      icon={<DocumentIcon viewBox='0 0 60 60' style={svgStyleWhite} />}
                    />
                  </MuiThemeProvider>
                  <MuiThemeProvider muiTheme={muiTheme}>
                    <RaisedButton
                      onTouchTap={this.handleTouchTap}
                      onClick={this.handleTouchTap}
                      label={this.state.byDateOpen ? "DONE": chooseDatesButtonTitle}
                      className={this.state.byDateOpen ? "raised-button raised-button-green": "raised-button"}
                      icon={<CalendarIcon viewBox='0 0 60 60' style={this.state.byDateOpen ? svgStyleWhite: svgStyleGreen} />}
                    />
                  </MuiThemeProvider>
                  <MuiThemeProvider muiTheme={muiTheme}>
                    <Popover
                      open={this.state.byDateOpen}
                      anchorEl={this.state.anchorEl}
                      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                      targetOrigin={{horizontal: 'right', vertical: 'top'}}
                      onRequestClose={this.handleRequestClose}
                    >
                      <RangePicker onRangeChange={this.handleChangeRange.bind(this)} />
                    </Popover>
                  </MuiThemeProvider>
                </div>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col xs={12} sm={12} md={6}>
              <MuiThemeProvider muiTheme={muiTheme}>
                <Paper className="paper" zDepth={1} >
                  <h4 className="column-title">Mileage Totals</h4>

                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Work:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_business_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Personal:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_personal_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Charity:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_charity_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Medical:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_medical_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Moving:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_moving_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Other:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_other_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Unclassified:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_uncategorized_miles).format('0,0.0')} mi</p>
                    </Col>
                  </Row>

                </Paper>
              </MuiThemeProvider>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <MuiThemeProvider muiTheme={muiTheme}>
                <Paper className="paper" zDepth={1} >
                  <h4 className="column-title">Transaction Totals</h4>

                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Revenue:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_revenue).format('$0,0.0')}</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Expenses:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{numeral(userProfile.total_expenses).format('$0,0.0')}</p>
                    </Col>
                  </Row>
                  <Row className="show-grid row-height-auto">
                    <Col xs={6} sm={6} md={6}>
                      <p>Profit:</p>
                    </Col>
                    <Col xs={6} sm={6} md={6}>
                      <p>{userProfile.total_revenue && userProfile.total_expenses && numeral((parseFloat(userProfile.total_revenue) + parseFloat(userProfile.total_expenses))).format('$0,0.0') }</p>
                    </Col>
                  </Row>

                </Paper>
              </MuiThemeProvider>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accountants/MainContentShowClient.js